import { QuillStatic } from '../../types'
import { EFFECT_TAG_NAME } from '../effect/constants'

export const registerSanitizingClipboardModule = (Quill: QuillStatic) => {
  const Delta = Quill.import('delta')
  const Clipboard = Quill.import('modules/clipboard')

  class SanitizingClipboard extends Clipboard {
    onPaste(e: ClipboardEvent) {
      if (!e.clipboardData) {
        return
      }

      e.preventDefault()

      const types = e.clipboardData.types

      if (!types.includes('text/html') && !types.includes('text/plain')) {
        return
      }

      const pastingHtml = e.clipboardData.getData('text/html')
      const pastingPlainText = e.clipboardData.getData('text/plain')

      const parser = new DOMParser()
      const parsed = parser.parseFromString(pastingHtml, 'text/html')

      /**
       * html 데이터가 있으면 우선 처리
       */
      if (!!parsed.body.textContent) {
        /**
         * 제스쳐, 일시정지, 멀티플센드태그, 이펙트 제거\
         * 필요한 경우 패턴 더 추가
         */
        parsed.querySelectorAll('gesture').forEach((node) => {
          node.remove()
        })
        parsed.querySelectorAll('div:has(.pauseButton)').forEach((node) => {
          node.remove()
        })
        parsed.querySelectorAll('multiplesendtag').forEach((node) => {
          node.remove()
        })
        parsed.querySelectorAll(EFFECT_TAG_NAME).forEach((node) => {
          node.remove()
        })

        /**
         * div 태그를 p 태그로 변경\
         * div 태그가 pause로 인식되는 경우가 있어서 p 태그로 변경하도록 함
         */
        const replaceDivToP = (node: Element) => {
          let currentNode = node

          if (node.tagName === 'DIV') {
            const p = document.createElement('p')
            p.replaceChildren(...node.childNodes)
            node.replaceWith(p)

            currentNode = p
          }

          currentNode.querySelectorAll('& > *').forEach((childNode) => {
            replaceDivToP(childNode)
          })
        }

        replaceDivToP(parsed.body)

        const sanitizedHtml = parsed.body.innerHTML

        const convertedHtml = this.convert(sanitizedHtml)

        const range = this.quill.getSelection()

        const delta = new Delta()
          .retain(range.index)
          .delete(range.length)
          .concat(convertedHtml)

        this.quill.updateContents(delta, 'user')

        this.quill.setSelection(range.index + convertedHtml.length(), 'silent')
      } else if (!!pastingPlainText) {
        /**
         * html 데이터가 없으면 plain text 데이터 처리
         */
        const range = this.quill.getSelection()

        const delta = new Delta()
          .retain(range.index)
          .delete(range.length)
          /**
           * delta의 insert로 넣어야 개행 문자가 제대로 처리됨
           */
          .insert(pastingPlainText)

        this.quill.updateContents(delta, 'user')

        this.quill.setSelection(range.index + pastingPlainText.length, 'silent')
      }
    }
  }

  Quill.register('modules/clipboard', SanitizingClipboard, true)

  return SanitizingClipboard
}
